export default "/institutions/flash.svg";